import { render, staticRenderFns } from "./AppPersonalData.vue?vue&type=template&id=e932ff42&scoped=true"
import script from "./AppPersonalData.vue?vue&type=script&lang=js"
export * from "./AppPersonalData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e932ff42",
  null
  
)

export default component.exports